(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["find-your-fit-option"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('find-your-fit-option')) {
    customElements.define('find-your-fit-option', class FindYourFitOption extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.mobileQuery = window.matchMedia('(max-width: 699px)');
        this.trigger = this.querySelector('[data-fit-option-trigger]');
        this.actions = this.querySelector('[data-fit-option-actions]');
        this.viewLink = this.querySelector('.find-your-fit__action-button--view');
        this.defaultViewUrl = this.viewLink?.getAttribute('href') || '';
        this.productForm = this.querySelector('[data-fit-product-form]');
        this.variantInput = this.querySelector('[data-fit-variant-input]');
        this.addButton = this.querySelector('.find-your-fit__action-button--add');
        this.addButtonContent = this.addButton?.querySelector('.button__content');
        this.defaultVariantId = this.variantInput?.value || '';
        this.defaultAddButtonDisabled = Boolean(this.addButton?.disabled);
        this.addButtonLabel = this.productForm?.dataset.addLabel || this.addButtonContent?.textContent?.trim() || '';
        this.soldOutButtonLabel = this.productForm?.dataset.soldOutLabel || '';

        this.viewLink?.addEventListener('click', () => this.syncTargetVariant(), {
          signal: this.abortController.signal
        });

        this.productForm?.querySelector('form')?.addEventListener('submit', () => this.syncTargetVariant(), {
          signal: this.abortController.signal,
          capture: true
        });

        document.addEventListener('variant:change', () => {
          window.requestAnimationFrame(() => this.syncTargetVariant());
        }, { signal: this.abortController.signal });

        this.syncTargetVariant();

        this.trigger?.addEventListener('click', () => {
          if (!this.mobileQuery.matches) return;

          const willExpand = !this.hasAttribute('data-expanded');

          if (willExpand) {
            this.closest('.find-your-fit__content-bottom')?.querySelectorAll('find-your-fit-option[data-expanded]').forEach((option) => {
              if (option !== this) option.closeActions();
            });
          }

          this.setExpanded(willExpand);
        }, { signal: this.abortController.signal });

        document.addEventListener('click', (event) => {
          if (this.mobileQuery.matches && !this.contains(event.target)) this.closeActions();
        }, { signal: this.abortController.signal });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeActions();
            this.trigger?.focus();
          }
        }, { signal: this.abortController.signal });

        this.mobileQuery.addEventListener('change', () => this.syncMode(), { signal: this.abortController.signal });
        this.syncMode();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      setExpanded(expanded) {
        this.toggleAttribute('data-expanded', expanded);
        this.trigger?.setAttribute('aria-expanded', String(expanded));
        this.actions?.setAttribute('aria-hidden', String(!expanded));

        if (this.actions) this.actions.inert = !expanded;
      }

      closeActions() {
        this.setExpanded(false);
      }

      normalizeOptionValue(value) {
        return String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
      }

      getSelectedColor() {
        const productInfo = document.querySelector('[id^="product-info-"]');
        const variantPicker = productInfo?.querySelector('variant-picker[update-url], variant-picker');
        if (!variantPicker) return '';

        const colorOption = Array.from(variantPicker.querySelectorAll('.variant-picker__option')).find((option) => {
          const label = this.normalizeOptionValue(option.querySelector('legend')?.textContent).replace(/:$/, '');
          return label.includes('color') || label.includes('colour');
        });

        return colorOption?.querySelector('.variant-picker__option-info .h-stack > span')?.textContent?.trim() || '';
      }

      setAddButtonLabel(label) {
        if (!this.addButtonContent || !label) return;

        this.addButtonContent.textContent = label;

        ['rotated-text', 'up-text'].forEach((attribute) => {
          if (this.addButtonContent.hasAttribute(attribute)) {
            this.addButtonContent.setAttribute(attribute, label);
          }
        });
      }

      resetTargetVariant() {
        if (this.viewLink && this.defaultViewUrl) this.viewLink.setAttribute('href', this.defaultViewUrl);
        if (this.variantInput && this.defaultVariantId) this.variantInput.value = this.defaultVariantId;
        if (this.addButton) this.addButton.disabled = this.defaultAddButtonDisabled;
        this.setAddButtonLabel(this.addButtonLabel);
      }

      syncTargetVariant() {
        this.resetTargetVariant();

        const selectedColor = this.normalizeOptionValue(this.getSelectedColor());
        if (!selectedColor) return;

        const matchedVariant = Array.from(this.querySelectorAll('[data-fit-target-variant]')).find((variant) => {
          return this.normalizeOptionValue(variant.dataset.color) === selectedColor;
        });

        if (!matchedVariant?.dataset.variantId) return;

        if (this.viewLink && this.defaultViewUrl) {
          const targetUrl = new URL(this.defaultViewUrl, window.location.origin);
          targetUrl.searchParams.delete('size');
          targetUrl.searchParams.set('variant', matchedVariant.dataset.variantId);
          this.viewLink.setAttribute('href', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
        }

        if (this.variantInput) this.variantInput.value = matchedVariant.dataset.variantId;

        if (this.addButton) {
          const isAvailable = matchedVariant.dataset.variantAvailable === 'true';
          this.addButton.disabled = !isAvailable;
          this.setAddButtonLabel(isAvailable ? this.addButtonLabel : this.soldOutButtonLabel);
        }
      }

      syncMode() {
        if (this.mobileQuery.matches) {
          this.closeActions();
        } else {
          this.removeAttribute('data-expanded');
          this.trigger?.setAttribute('aria-expanded', 'false');
          this.actions?.setAttribute('aria-hidden', 'false');
          if (this.actions) this.actions.inert = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
